import { ref } from 'vue';
import { httpService } from '../services/httpService';
import { log, error as logError } from '../utils/DebugLogger';
import '../contracts/AdditionalServiceAttributes_SalvarAtributosInput';

import '../contracts/AdditionalServiceAttributes_AtributosResponse';
import '../contracts/AdditionalServiceAttributes_SalvarAtributosResponse';
import type { AdditionalServiceAttributes_SalvarAtributosInput } from '../contracts/AdditionalServiceAttributes_SalvarAtributosInput';
import type { So_CategoryAttributeBindingInputRow } from '../contracts/So_CategoryAttributeBindingInputRow';

export function useSOAdditionalServiceAttributes() {
  const isLoading = ref(false);
  const error = ref<string | null>(null);
  const basePath = '/index.php/so/additional_service_attributes';

  const fetchServiceAttributes = async (serviceId: number) => {
    log('useSOAdditionalServiceAttributes', 'fetchServiceAttributes', 'Fetching additional-service attribute bindings', { serviceId });
    isLoading.value = true;
    error.value = null;
    try {
      const response = await httpService.get(`${basePath}/atributos/${serviceId}`, { responseContract: 'AdditionalServiceAttributes_AtributosResponse' });
      if (response.success) {
        return response.dados || [];
      }
      throw new Error(response.error || 'Erro ao buscar atributos do servico adicional');
    } catch (err: any) {
      logError('useSOAdditionalServiceAttributes', 'fetchServiceAttributes', 'Error', err);
      error.value = err.message;
      throw err;
    } finally {
      isLoading.value = false;
    }
  };

  const saveServiceAttributes = async (serviceId: number | string, attributes: So_CategoryAttributeBindingInputRow[]) => {
    const payload: AdditionalServiceAttributes_SalvarAtributosInput = { attributes };
    log('useSOAdditionalServiceAttributes', 'saveServiceAttributes', 'Saving additional-service attribute bindings', { serviceId, payload });
    isLoading.value = true;
    error.value = null;
    try {
      const response = await httpService.post(`${basePath}/salvar_atributos/${serviceId}`, payload, { inputContract: 'AdditionalServiceAttributes_SalvarAtributosInput', responseContract: 'AdditionalServiceAttributes_SalvarAtributosResponse' });
      if (response.success) {
        return response;
      }
      throw new Error(response.error || 'Erro ao salvar atributos do servico adicional');
    } catch (err: any) {
      logError('useSOAdditionalServiceAttributes', 'saveServiceAttributes', 'Error', err);
      error.value = err.message;
      throw err;
    } finally {
      isLoading.value = false;
    }
  };

  return {
    isLoading,
    error,
    fetchServiceAttributes,
    saveServiceAttributes
  };
}
